import { toast } from "react-toastify";

import api from "../api";

type CompanyByHost = {
  id: number;
  logo: string;
  name: string;
};
async function getCompanyHost(host: string) {
  try {
    const { data } = await api.get<CompanyByHost>(`/company/host/`, { params: { host } });

    return [false, data] as const;
  } catch (error) {
    toast.error("");
    console.error("", error);
    return [true, null] as const;
  } finally {
    console.log("getCompanyHost executed with host:", host);
  }
}

async function getTodayAttendanceByCompanyId(id: number) {
  try {
    const { data } = await api.get<{ id: number; status: string }>(`/attendances/today/company/${id}`);
    const attendance = data?.id && data?.status ? data.id : 0;
    localStorage.setItem("attendance", String(attendance));

    return { data: attendance, isSuccess: true, isError: false };
  } catch (error) {
    console.error(`Error fetching today's attendance by company ID: ${id}`, error);
    toast.error("Erro ao buscar a presença do dia");
    localStorage.removeItem("attendance");

    return { data: null, isSuccess: false, isError: true, error };
  } finally {
    console.log(`getTodayAttendanceByCompanyId executed with company ID: ${id}`);
  }
}

export const attendanceQueries = {
  getCompanyHost,
  getTodayAttendanceByCompanyId
};
